export { InfoPage as default } from '@/components/enpages/Ir/Stock/Info'
